import compact from 'lodash.compact';
import flatten from 'lodash.flatten';
import uniqBy from 'lodash.uniqby';
import { useMemo } from 'react';

import { Warning } from '@/components/common/warning';
import { IBatch } from '@/features/single-measurement/types';

export const WarningsList = ({ batches }: { batches?: IBatch[] }) => {
  const _warnings = batches
    ? batches.map(({ resultStat }) => {
        const { densityWarning, viabilityWarning, concentrationWarning } = resultStat;
        return [densityWarning, viabilityWarning, concentrationWarning];
      })
    : [];

  const warnings = useMemo(
    () => uniqBy(compact(flatten(_warnings)), 'message'),
    [batches],
  );

  const renderWarningList = warnings.map((warning) => (
    <Warning key={warning?.message} {...warning} />
  ));

  return <div className="flex flex-col gap-4">{renderWarningList}</div>;
};
